import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-measure-calculation-details',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="measure-calculation-compact">
     
       <div class="calculation-grid">
        <div class="calc-box">
          <div class="calc-value ipp-value">{{ipp | number}}</div>
          <div class="calc-label">IPP</div>
        </div>
          <div class="calc-box">
          <div class="calc-value excep-value">{{denomException | number}}</div>
          <div class="calc-label">Exceptions</div>
        </div>
        
        <div class="calc-box">
          <div class="calc-value denom-value">{{denominator | number}}</div>
          <div class="calc-label">Denominator</div>
        </div>
        

        
        <div class="calc-box">
          <div class="calc-value numer-value">{{numerator | number}}</div>
          <div class="calc-label">Numerator</div>
        </div>
      </div>
      
      <div class="calculation-formula">
        <div class="formula-row">
          <span class="formula-label">Adjusted Denominator:</span>
          <span class="formula-value">{{ipp | number}} - {{denomException | number}} = {{adjustedDenominator | number}}</span>
        </div>
        <div class="formula-row">
          <span class="formula-label">Performance:</span>
          <span class="formula-value">{{numerator | number}} ÷ {{adjustedDenominator | number}} × 100% = {{formattedPerformance}}%</span>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .calculation-grid{
      display: flex;
      flex-direction: row;

  box-shadow: 0px 4px 8px 0px #00000026;
  }
      .formula-label{
      font-weight: 500;
      color: #333;
      padding-right: 8px;
      }

    .calculation-details-container {
      padding: 16px;
    }
    
    .calculation-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
    }
    
    .header-title {
      font-weight: 500;
      margin: 0;
      color: #333;
    }
    
    .performance-display {
      font-size: 12px;
      padding: 4px 8px;
      background-color: #e1f5fe;
      color: #03a9f4;
      border-radius: 4px;
    }
    
    .calculation-boxes {
      display: flex;
      gap: 16px;
      margin-bottom: 16px;
    }
    
    .calc-box {
      flex: 1;
      padding: 6px;
      background-color: #f5f5f5;
      border-radius: 4px;
      text-align: center;
    }
    
    .calc-value {
      font-size: 20px;
      font-weight: 500;
      margin-bottom: 4px;
    }
    
    .calc-label {
      font-size: 12px;
      color: #666;
    }
    
    .ipp-value { color: #2196f3; }
    .denom-value { color: #4caf50; }
    .excep-value { color: #ff9800; }
    .numer-value { color: #9c27b0; }
    
    .calculation-formula {
      padding-top: 12px;
      border-top: 1px solid #e0e0e0;
      font-size: 13px;
      color: #666;
    }
    
    .formula-row {
      text-align: right;
      justify-content: space-between;
      margin-bottom: 8px;
    }
  `]
})
export class MeasureCalculationDetailsComponent {
  @Input() ipp: number = 0;
  @Input() denominator: number = 0;
  @Input() denomException: number = 0;
  @Input() numerator: number = 0;
  @Input() performance: number = 0;

  get adjustedDenominator(): number {
    return this.ipp - this.denomException;
  }

  get formattedPerformance(): string {
    return (this.performance * 100).toFixed(2);
  }
}
